import React, { Component } from 'react'
import AnimateHeight from 'react-animate-height'
import i18n from 'i18next'
import * as R from 'ramda'

import Checkbox from '../../components/form/Checkbox'

import '../question-builder.scss'

class ProductTypes extends Component {
    renderCheck = (onChange, options, value, indKey, proKey, surKey, respKey) => {
        const respCode = `${indKey}-${proKey}-${surKey}-${respKey}`
        const obj = R.pathOr({}, [proKey, 'children', surKey, 'children', respKey], options)
        return (
            <li className="resp-opt">
                <Checkbox
                    onBlur={({ value }) => { onChange(value, [respCode]) }}
                    label={obj.label}
                    labelDir="left"
                    cssClass="resp-check"
                    name={obj.value}
                    checked={value.includes(respCode)}
                    stopPropagation
                />
            </li>
        )
    }

    renderList = (onChange, options, value, proKey, respCodes) => {
        const { indKey } = options[proKey]
        const surKeys = Object.keys(options[proKey].children)
        return (
            surKeys.map((surKey) => (
                <div>
                    <div className="sur-wrapper">
                        <p className="title">{options[proKey].children[surKey].label}</p>
                        <Checkbox
                            onBlur={({ value }) => { onChange(value, respCodes[surKey]) }}
                            label={i18n.t('gen_select_all')}
                            labelDir="left"
                            cssClass="sur-check"
                            name={options[proKey].children[surKey].value}
                            checked={respCodes[surKey].every(
                                (respCode) => (value.includes(respCode)),
                            )}
                            stopPropagation
                        />
                    </div>
                    <ul className="resp-list">
                        {
                            Object.keys(options[proKey].children[surKey].children).map(
                                (respKey) => (
                                    this.renderCheck(
                                        onChange,
                                        options,
                                        value,
                                        indKey,
                                        proKey,
                                        surKey,
                                        respKey,
                                    )
                                ),
                            )
                        }
                    </ul>
                </div>
            ))
        )
    }

    renderCheckboxAccordion = (options, onChange, value, isAccClose, toggleCheckAcc) => {
        const respCodes = Object.keys(options).reduce((acc, proKey) => {
            const { indKey } = options[proKey]
            acc[proKey] = Object.keys(options[proKey].children).reduce((proAcc, surKey) => {
                proAcc[surKey] = Object.keys(options[proKey].children[surKey].children).map(
                    (respKey) => (
                        `${indKey}-${proKey}-${surKey}-${respKey}`
                    ),
                )
                return proAcc
            }, {})
            return acc
        }, {})
        const resps = Object.keys(respCodes).reduce((acc, proKey) => {
            acc[proKey] = Object.values(respCodes[proKey]).flat()
            return acc
        }, {})
        return (
            <React.Fragment>
                {Object.keys(options).map((proKey, index) => (
                    <div className="acc-comp" key={index}>
                        <div className="header" onClick={() => { toggleCheckAcc(index) }}>
                            <i className={`arrow-icon fa-regular ${!isAccClose[index] ? 'fa-chevron-up' : 'fa-chevron-down'}`} />
                            <p className="title">{options[proKey].label}</p>
                            <Checkbox
                                onBlur={({ value }) => {
                                    onChange(value, resps[proKey])
                                }}
                                label={i18n.t('gen_select_all')}
                                labelDir="left"
                                cssClass="pro-check"
                                name={options[proKey].value}
                                checked={resps[proKey].every(
                                    (respCode) => (value.includes(respCode)),
                                )}
                                stopPropagation
                            />
                        </div>
                        <AnimateHeight
                            // className="check-acc"
                            duration={250}
                            height={!isAccClose[index] ? 'auto' : 0}
                        >
                            <hr className="divider" />
                            <div className="checks-wrapper">
                                {this.renderList(
                                    onChange, options, value, proKey, respCodes[proKey],
                                )}
                            </div>
                        </AnimateHeight>
                    </div>
                ))}
            </React.Fragment>
        )
    }

    render() {
        const {
            options, onChange, value, isAccClose, toggleCheckAcc,
        } = this.props
        return (
            <div id="product-types">
                {this.renderCheckboxAccordion(options, onChange, value, isAccClose, toggleCheckAcc)}
            </div>
        )
    }
}

export default ProductTypes
